interface IntroProps {
  heading: string
}
const Intro: React.FC<IntroProps> = ({ heading }) => (
  <div className='mx-auto flex w-full max-w-sm flex-col md:max-w-none'>
    <h1 className='max-w-sm items-baseline text-2xl font-semibold capitalize leading-tight tracking-tight text-gray-800 md:pr-8 md:text-3xl'>
      {heading}
    </h1>
  </div>
)

export default Intro
